export default __webpack_public_path__ + "static/media/5.e4cd3fc6.png";